module.exports = __webpack_public_path__ + "file.037acab7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/file.svg
// module id = C2ZR
// module chunks = 0